import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Examples } from "../../../Constant";
import HeaderCard from "../../Common/HeaderCard";
import Timeline1 from "./Timeline1";

const TimelineContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle="Timeline" parent="Bonus Ui" title="Timeline" />
      <Row>
        <Col sm="12">
          <Card>
            <HeaderCard title={`${Examples} 1`} />
            <CardBody>
              <Timeline1 />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default TimelineContainer;
